
function applyGliderSlider(){

  const glider = new Glider(document.querySelector(".gliderProduct"), {
    slidesToShow: 1,
    dots: ".dots",
    draggable: true,
    arrows: {
      prev: ".glider-prev",
      next: ".glider-next"
    },
    responsive: [
      { // screens greater than >=300px
        breakpoint: 300,
        settings: { // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 1,
          slidesToScroll: "auto",

          duration: 0.25
        }
      }, { // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          duration: 0.25
        }
      }
    ]
  })



}
applyGliderSlider();


document.addEventListener('shopify:section:load', function(event){
  applyGliderSlider();

});





